export const getBrowserBodyFontSize = () =>
  +window
    .getComputedStyle(document.body)
    .getPropertyValue('font-size')
    .slice(0, -2);
